import React from 'react';
import Arrow from '../components/Arrow';
import './Home.css';

const links = [
  { href: '#/about', label: 'About' },
  { href: '#/work', label: 'Work' },
  { href: '#/contact', label: 'Contact' },
];

export default function Home() {
  return (
    <main className="home">
      <p className="sr-only">
        Temitope Abodunrin is a software engineer and designer based in Lagos, Nigeria, building web applications
        with Java, Spring Boot, Python, Go and React, and designing brands, logos and campaigns.
      </p>

      <div className="shell">
        <div className="meta-row fade-in">
          <span className="meta">Software Engineer · Designer</span>
          <span className="meta">Lagos · Nigeria</span>
        </div>
      </div>

      <div className="shell home-mid">
        <h1 className="display home-name">
          <span className="mask home-small"><span style={{ '--d': 0 }}><span className="stroked">Hello, I'm</span></span></span>
          <span className="mask home-big"><span style={{ '--d': 1 }}><span className="accent">Temitope</span></span></span>
          <span className="mask home-big"><span style={{ '--d': 2 }}><span className="accent">Abodunrin</span></span></span>
          <span className="mask home-small">
            <span style={{ '--d': 3 }}><span className="stroked">But you can call me </span><span className="accent">Topseen</span></span>
          </span>
        </h1>
      </div>

      <div className="shell">
        <div className="home-foot fade-in" style={{ '--d': 5 }}>
          <p>
            I build clean, efficient and scalable web applications, end to end: interface, API and database,
            and I design the brands around them.
          </p>
          <nav aria-label="Pages">
            {links.map((l, i) => (
              <a key={l.href} href={l.href}>
                <span className="meta">{String(i + 1).padStart(2, '0')}</span>
                {l.label}
                <Arrow />
              </a>
            ))}
          </nav>
        </div>
      </div>
    </main>
  );
}
